import React, {Component} from 'react';
import '../css/Page.css';

class PageSoaIso extends Component {

    render() {
        return (
                <div className="page">
                    <article>

                        <p><strong>Il servizio &egrave; finalizzato all&rsquo;ottenimento e/o al rinnovamento da parte delle imprese, dell&rsquo;attestazione di qualificazione per partecipare alle gare d&rsquo;appalto.</strong></p>

                        <p>Le imprese che intendono eseguire lavori pubblici su tutto il territorio nazionale, per importi superiori a &euro; 150.000, devono essere in possesso di un &ldquo;Attestato di Qualificazione rilasciato da una SOA (Societ&agrave;
                            Organismo di Attestazione) regolarmente autorizzata dall&rsquo;Autorit&agrave; per la vigilanza dei Contratti Pubblici di Lavori, Servizi e Forniture.
                            <br/>Le Imprese sono qualificate dalle SOA per categorie di opere generali (OG), per categorie di opere specializzate (OS), nonch&eacute; per le prestazioni di sola costruzione e per le prestazioni
                            di progettazione e costruzione e classificate nell&rsquo;ambito delle categorie loro attribuite, secondo importi definiti classifiche.
                            <br/>L&rsquo;attestazione di qualificazione in una categoria abilita l&rsquo;Impresa a partecipare alle gare ed eseguire lavori nei limiti della propria classifica incrementata di un quinto.
                            <br/>Per ottenere l&rsquo;attestato SOA occorre dimostrare di aver eseguito dei lavori che possono essere pubblici, privati o realizzati in proprio.
                            <br/>L&rsquo;attestato di qualificazione SOA ha validit&agrave; quinquennale (con l&rsquo;obbligo della verifica di validit&agrave; al terzo) e viene valutata sulla base di un&rsquo;analisi tecnica ed economica degli ultimi cinque esercizi di attivit&agrave; dell&rsquo;impresa, precedenti alla richiesta di qualificazione.
                            <br/>L&rsquo;Areamultiservice orienta ed assiste le aziende nel corso di tutto il processo di Attestazione SOA, dalla verifica gratuita all&rsquo;assistenza per il mantenimento.</p>
                        <p>Infatti, offre i seguenti servizi:</p>
                        <ul>
                            <li>Verifica preliminare dei requisiti gratuita;</li>
                            <li>Consulenza specializzata all&rsquo;ottenimento dell&rsquo;Attestazione SOA;</li>
                            <li>Assistenza all&rsquo;ottenimento e/o al rinnovo dell&rsquo;Attestazione SOA;</li>
                            <li>Preparazione delle dichiarazioni necessarie, fino all&rsquo;esito dell&rsquo;istruttoria;</li>
                            <li>Assistenza durante tutto l&rsquo;iter di ottenimento dell&rsquo;Attestazione;</li>
                            <li>Assistenza per il successivo mantenimento triennale/quinquennale.</li>
                        </ul>

                        <p align="justify">Attestati con noi, l&rsquo;Areamultiservice ti riserva un pacchetto di servizi <strong>GRATUITI</strong> per l&rsquo;intera durata dell&rsquo;attestazione</p>

                        <p>Per richiedere il servizio vi preghiamo di inviare i seguenti documenti tramite mail.</p>
                        <p>Mail:&nbsp;<a href="mailto:info@areamultiservice.it">info@areamultiservice.it</a> e/o <a href="mailto:serviziappalti@libero.it">serviziappalti@libero.it</a></p>
                        <p>Per ulteriori informazioni contattare il responsabile Ufficio Gare al numero <strong>329/8177540</strong>.</p>

                    </article>
                </div>
        );
    }
}

export default PageSoaIso;


// WEBPACK FOOTER //
// ./src/page/js/PageSoaIso.js